import { render, staticRenderFns } from "./ProcessesForm.vue?vue&type=template&id=361299a8&"
import script from "./ProcessesForm.vue?vue&type=script&lang=js&"
export * from "./ProcessesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports